/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyInvitationRequest
 */
export interface VerifyInvitationRequest {
    /**
     * 
     */
    passcode: string;
}

/**
 * Check if a given object implements the VerifyInvitationRequest interface.
 */
export function instanceOfVerifyInvitationRequest(value: object): value is VerifyInvitationRequest {
    if (!('passcode' in value) || value['passcode'] === undefined) return false;
    return true;
}

export function VerifyInvitationRequestFromJSON(json: any): VerifyInvitationRequest {
    return VerifyInvitationRequestFromJSONTyped(json, false);
}

export function VerifyInvitationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyInvitationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'passcode': json['passcode'],
    };
}

export function VerifyInvitationRequestToJSON(json: any): VerifyInvitationRequest {
    return VerifyInvitationRequestToJSONTyped(json, false);
}

export function VerifyInvitationRequestToJSONTyped(value?: VerifyInvitationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'passcode': value['passcode'],
    };
}

